
import React from 'react';
import { RealTimeDashboard } from '@/components/Dashboard/RealTimeDashboard';
import RecentTimeEntries from '@/components/Dashboard/RecentTimeEntries';
import WeeklyStats from '@/components/Dashboard/WeeklyStats';

const Dashboard = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8">Tableau de Bord - Suivi de Temps</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <RealTimeDashboard />
        </div>
        
        <div className="lg:col-span-1">
          <WeeklyStats />
        </div>
        
        <div className="lg:col-span-1">
          <RecentTimeEntries />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
